/**
 * 用户
 */

import { HTTP_ALB } from '../axios';

//  用户列表
export const getstafflist = params => {
	return HTTP_ALB.get('/foundation/staff/list', params);
};
// 添加用户
export const addstaff = params => {
	return HTTP_ALB.post('/foundation/staff/add', params);
};
// 编辑用户
export const editstaff = params => {
	return HTTP_ALB.post('/foundation/staff/edit', params);
};

// 获取用户详情
export const getstaffinfo = params => {
	return HTTP_ALB.get('/foundation/staff/info', params);
};

// 用户添加人脸
export const add_face = params => {
	return HTTP_ALB.post('/foundation/staff/add_face', params);
};

// 用户添加人脸
export const get_face = params => {
	return HTTP_ALB.get('/foundation/staff/get_face', params);
};

// 用户删除人脸
export const delete_face = params => {
	return HTTP_ALB.post('/foundation/staff/del_face', params);
};


// 获取截屏
export const get_live_face = params => {
	return HTTP_ALB.get('/live/live/live_face', params);
};
// 获取UC角色列表
export const get_staff_role_list = params => {
	return HTTP_ALB.get('/staff/role/list', params);
};
// 校验账户 姓名、手机号、邮箱是否重复
export const staff_check = params => {
	return HTTP_ALB.post('/foundation/staff/addcheck', params);
};
// 常用数据存储
export const trail_add = params => {
	return HTTP_ALB.post('/user/trail/add', params);
};
// 常用数据查询
export const user_trail = params => {
	return HTTP_ALB.get('/home/user/trail', params);
};
// 常用数据查询
export const planDetail = params => {
	return HTTP_ALB.post('/anchor/plan/detail', params);
};